import { BUILD_VERSION } from '../../environments/build-version';

const STORAGE_KEY = '3PLSCurrentBuildVersion';

export async function clearBrowserCacheIfDeployed(): Promise<void> {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored !== BUILD_VERSION) {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }

      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((r) => r.unregister()));
      }
    }

    localStorage.setItem(STORAGE_KEY, BUILD_VERSION);
  } catch (_) {
    // Never throws — Angular must always bootstrap regardless
  }
}
